import { createSelector } from '@ngrx/store';

import * as Utils from '@shared/core/utils';
import * as Statics from '@shared/core/statics';

import { getHistoryOrderByOrderGUID } from '../getHistoryOrderByOrderGUID';

export const getHistoryOrderTypeGroup = (orderGUID: string) =>
    createSelector(getHistoryOrderByOrderGUID(orderGUID), (order) => {
        const config = new Statics.ConfigStatic().current;

        if (!config || !order?.data?.OrderTypeId) return null;

        return new Utils.CollectionTypeGroupDetector(order.data.OrderTypeId, config).getCollectionType();
    });
